import { MessageSquareReply, Plus } from "lucide-react";

const CANNED = [
  { t: "Yatırım Onayı", m: "Yatırımınız başarıyla hesabınıza tanımlanmıştır. İyi oyunlar dileriz." },
  { t: "Çekim Bilgilendirme", m: "Çekim talebiniz alınmıştır, en kısa sürede işleme alınacaktır." },
  { t: "IBAN Talebi", m: "İşleminizi tamamlamak için lütfen güncel IBAN bilginizi paylaşınız." },
  { t: "Belge Talebi", m: "Hesap doğrulaması için kimlik ön yüz fotoğrafınızı iletebilir misiniz?" },
  { t: "Teşekkür", m: "İlginiz için teşekkür ederiz, başka bir konuda yardımcı olabilir miyiz?" },
  { t: "Bekletme", m: "Talebinizi inceliyoruz, kısa süre içinde dönüş sağlayacağız." },
];

export default function HazirCevaplar() {
  return (
    <div className="space-y-5" data-testid="page-hazir-cevaplar">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
            <MessageSquareReply className="text-[#F0651E]" size={22} />
          </div>
          <div>
            <h1 className="text-xl font-extrabold">Hazır Cevaplar</h1>
            <p className="text-xs text-slate-500">Sık kullanılan mesaj şablonları</p>
          </div>
        </div>
        <button className="flex items-center gap-2 rounded-xl bg-[#F0651E] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#d9560f]">
          <Plus size={16} /> Yeni Ekle
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CANNED.map((c) => (
          <div key={c.t} className="bg-white dark:bg-[#151824] rounded-2xl p-5 shadow-sm border border-slate-100 dark:border-slate-800">
            <div className="font-bold text-[#F0651E]">{c.t}</div>
            <p className="text-sm text-slate-600 dark:text-slate-300 mt-2 leading-relaxed">{c.m}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
